function doesValueExist<T>(value: T | null | undefined) {
  return !(value === null || value === undefined);
}

export default doesValueExist;
